import { KeyboardArrowRight,Edit,PermIdentity,PowerSettingsNew, Delete, Update, Cookie } from '@mui/icons-material'
import {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { RemoveUserRole } from "../services/UserRole";
import {Getauth,Removeauth} from "../services/Auth"
import { CartUpdate } from "../services/CartUpdate";
import { useSelector, useDispatch } from "react-redux";
import { delAllCart } from "../redux/action";
import { Url } from '../services/Constants';
import { setHeader } from '../services/Headers';
import { GetUserRole } from '../services/UserRole';
import toast from 'react-hot-toast';
import axios from 'axios';
import Model from './Model';
import { setImgHeader } from '../services/Headers';


export default function SideEditBar({profileData,profilepics,feedHandle}) {


  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch(); 
   
  const Navigate = useNavigate()
  const [selectedFile, setSelectedFile] = useState(null);
  const [profiles, setProfiles] = useState(profileData)
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  useEffect(() => {
  }, [profiles]);



  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const profilePicData = reader.result;
        setProfiles((prevData) => ({
          ...prevData,
          profile_pic: profilePicData,
        }));
        profilepics(profilePicData);

        const formData = new FormData();
        formData.append('profile_pic', file);

        try {
          const endpoint = profileData.role === "buyer"
            ? `${Url}/buyer/profile/update`
            : `${Url}/seller/profile/update`;

          const result = await axios.put(endpoint, formData, setImgHeader());
          if (result.data.response_code === 200) {
            toast.success("Profile picture uploaded successfully.");
            setProfiles((prevData) => ({
              ...prevData,
              profile_pic: profilePicData,
          }));
          } else {
            toast.error("Failed to upload profile picture.");
          }
        } catch (error) {
          console.error("Error uploading profile picture:", error);
          toast.error("An error occurred while uploading the profile picture.");
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditClick = () => {
    document.getElementById('fileInput').click();
  };

  const feedControl = (data)=>{
    feedHandle(data)
  }


  const logOutHandle = (e) => {
    dispatch(delAllCart());
    Removeauth()
    RemoveUserRole()
    CartUpdate()
    localStorage.clear()
    sessionStorage.clear()
    // Cookie.clearAll()
    Navigate('/');
  }


  const deleteAccount = async () => {
    const endpoint = `${Url}/sessions/delete_user_account`;
    try {
      const response = await axios.delete(endpoint, setHeader());
      if (response.data.response_code === 200) {
        toast.success("Account deleted successfully.");
        logOutHandle();
      } else {
        toast.error("Failed to delete account.");
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error("An error occurred while deleting the account.");
    }
  };



  return (
    <div className='SideEditBar-container  ml-4 w-full relative max-lg:h-screen pt-2 max-lg:bg-white max-sm:ml-0  '>
      <div className="sidebar w-full px-[4%] lg:w-[95%]  ">
                <div className="profile-container w-full mb-4 pb-2 shadow-md border-r-2">
                    <div className="profile-edit-hover w-28 h-28 border-2 my-3 mx-auto border-gray-400 rounded-full lg:w-20 lg:h-20  ">
                      <img
                        src={profiles?.profile_pic || profileData?.profile_pic || "../assets/profile_pic.webp"}
                        className="object-cover w-full h-full cursor-pointer rounded-full"
                        alt="profile_pic"
                        onClick={handleEditClick}
                      />
                    </div>
                    <div className="hello text-center">Hello,</div>
                    <div className="user-name w-full text-center text-amber-950 font-semibold font-poppins text-xl">
                      {profileData?.firstName} {profileData?.lastName}
                    </div>
                  </div>
                  <input
                    type="file"
                    id="fileInput"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                  />
        <div className="account-bottom  pb-4 shadow-md">
        {profileData?.role ==="buyer"?<div className="Profile my-[5%] cursor-pointer flex justify-between items-center border-b" onClick={()=>feedControl("orders")}>
            <div className="item flex justify-end items-center py-3 ml-10 max-2xl:ml-2 " onClick={()=>feedControl("orders")}>
              <img src="../assets/package-box.png" alt="" className='h-6 w-6 text-amber-950 lg:h-4 lg:w-4' />
            <span className='font-bold font-poppins text-amber-950 text-xl ml-10 max-2xl:text-base max-2xl:ml-5' onClick={()=>feedControl("orders")}>MY ORDERS</span>
            </div>
            <div className="">
            <KeyboardArrowRight className=''/>
            </div>
        </div>:""}
        <div className="my-account my-[5%] cursor-pointer border-b">
        <div className="item flex items-center ml-10 mb-4 max-2xl:ml-2">
            <PermIdentity/>
            <span className='font-bold font-poppins text-amber-950 text-xl ml-10 max-2xl:text-base max-2xl:ml-5 max-sm:text-sm'>ACCOUNT SETTINGS</span>
            </div>
            <div className=' text-amber-950 font-semibold mb-2 py-1 hover:bg-red-50 max-2xl:py-0'>
              <span className="k ml-[100px] max-2xl:ml-12 font-poppins" onClick={()=>feedControl("profile")}>Personal Information</span>
              </div>
        </div>
        <div className="favorites my-[5%] cursor-pointer">
        <div className="logout item flex items-center ml-10 mb-5 max-2xl:ml-2">
          <PowerSettingsNew className='text-amber-950'/>
          <span className="k font-bold font-poppins text-amber-950 text-xl ml-10 max-2xl:text-base max-2xl:ml-5" onClick={logOutHandle}>Logout</span>
        </div>
        <div className="delete item flex items-center ml-10 mb-5 max-2xl:ml-2" onClick={() => setIsModalOpen(true)}>
          <Delete className='text-amber-950'/>
          <span className="k font-bold font-poppins text-amber-950 text-xl ml-10 max-2xl:text-base max-2xl:ml-5">Delete Account</span>
        </div>
        </div>
        </div>
      </div>

      <Model
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={deleteAccount}
        message="Are you sure you want to delete your account? This action cannot be undone."
      />
    </div>
  )
}
